import './App.css';
import { MainPage } from './module';
function App() {
  return (
    <div>
    <MainPage/>
    </div>
  );
}

export default App;
